export default __webpack_public_path__ + "static/media/consul.57a8fe56.svg";